import type { ColorPickerEventPayload } from '@components/sp-color-picker/src/types/color-picker.type';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ThemeStateService } from '@sites/site-theme/src/state';
import { SpColorPickerModule } from '@components/sp-color-picker/src/sp-color-picker.module';

@Component({
    selector: 'web-color-picker',
    templateUrl: './web-color-picker.component.html',
    styleUrls: ['./web-color-picker.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SpColorPickerModule],
})
export class WebColorPickerComponent {
    private readonly themeState = inject(ThemeStateService);

    @Input() public color!: string;
    @Input() public ariaLabel = 'Color';
    @Input() public positionLeft = false;
    @Input() public hideGradient = false;

    @Output() public colorChangeEvent = new EventEmitter<ColorPickerEventPayload>();

    public readonly selectedThemeColors = this.themeState.selectedColors;
}
